import {normalize, schema, denormalize} from 'normalizr';

const language = new schema.Entity('languages', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {languages: [language]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = language;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = language;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default language;
